import { render, staticRenderFns } from "./nodata.vue?vue&type=template&id=39a1a44c&scoped=true&"
import script from "./nodata.vue?vue&type=script&lang=js&"
export * from "./nodata.vue?vue&type=script&lang=js&"
import style0 from "./nodata.vue?vue&type=style&index=0&id=39a1a44c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a1a44c",
  null
  
)

export default component.exports